import * as React from 'react';
import * as _ from 'underscore';

import { WidgetBase } from '../../../_common/platform/ts/WidgetBase';
import { ProgressBar } from '../../../_common/platform/tsx/ProgressBar';

export class DirsTemplatesSingle extends React.Component<any, any> {
    constructor(props) {
        super(props);

        this.state = {
            select: null
        };
    }

    getClickHandler = (id, data, name) => {
        if (this.props.allowSelect !== true)
            //VR: do not allow to select Template!
            return null;

        var _self = this;

        return function (e) {
            _self.setState({
                select: id
            });

            if (typeof _self.props.onSelect === 'function') {
                _self.props.onSelect(id, data, name);
            }
        };
    };

    _getView = () => {
        let classDisallowPointer = '';

        if (this.props.allowSelect !== true)
            //VR: do not allow to select a WS row!
            classDisallowPointer = ' tr-disallow-pointer';

        if (this.props.content == null) {
            return (
                <em className="empty-non-select">
                    <span className="arrow">←</span>
                    <span>{'Select a folder on the left'}</span>
                </em>
            );
        }

        if (this.props.content.length === 0) {
            return <em>{'Folder is empty'}</em>;
        }

        return (
            <table className="table">
                <thead>
                    <tr>
                        <th className="cell-id"></th>

                        <th>{'Name'}</th>
                    </tr>
                </thead>

                <tbody>
                    {_.map(this.props.content, (item: any, i) => {
                        if (item.data == null) {
                            return;
                        }

                        var constr = WidgetBase.getConstructorByName(item.data.type);

                        var icon;

                        if (constr != null) {
                            icon = <span className={'glyphicon glyphicon-' + constr.icon}></span>;
                        }

                        return (
                            <tr
                                key={i}
                                onClick={this.getClickHandler(item.wtid, item.data, item.name)}
                                className={(this.state.select === item.wtid ? 'selected' : '') + classDisallowPointer}
                            >
                                <td className="cell-id">{icon}</td>

                                <td>{item.name}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        );
    };

    _getContent = () => {
        if (this.props.loading) {
            return <ProgressBar />;
        } else {
            return this._getView();
        }
    };

    render() {
        return <div className="dir-single dir-single-templates">{this._getContent()}</div>;
    }
}
